export const COLLAPSED_WIDTH = "4.5rem"; // ~64px
export const EXPANDED_WIDTH = "16.25rem"; // ~260px
export const SUBMENU_WIDTH = "20rem"; // ~320px
export const ROW_H = "3.125rem";

export const COLLAPSED_WIDTH_PX = 68;
export const EXPANDED_WIDTH_PX = 260;
export const SUBMENU_WIDTH_PX = 320;
